import { render } from "./CusButton.vue?vue&type=template&id=963a552a&scoped=true"
import script from "./CusButton.vue?vue&type=script&lang=js"
export * from "./CusButton.vue?vue&type=script&lang=js"

import "./CusButton.vue?vue&type=style&index=0&id=963a552a&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/dayungs_pos_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-963a552a"]])

export default __exports__